import {Edit, MoreVert} from "@mui/icons-material";
import {Chip, IconButton, Menu, MenuItem, Typography} from "@mui/material";
import React from "react";
import {Black, Blue3, Grey17, Grey6} from "../../theme/styles";
import css_self from "../Navigation/css/NavBar.module.scss";
import {EnlilTable} from "../EnlilTable";
import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import EventBus from "../../util/EventBus";
import css_buttons from "../Common/css/CCButton.module.scss";
import EmployeeAdminUserGroupFormApplet from "../../eoec/applet/impl/Administration/EmployeeAdminUserGroupFormApplet";

class EmployeeAdminUserGroupTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("employee-admin-user-group-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("employee-admin-user-group-form-applet-save", this.onCancelHandler);
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("employee-admin-user-group-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("employee-admin-user-group-form-applet-save", this.onCancelHandler);
    }

    renderStandardSingleCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let recordActive = this.state.buffer[params.row.id].get("Status");
        let textColor = recordActive === 'Active' ? this.state.buffer[params.row.id].get("Status") === 'Active' ? Black : Grey6: Grey6

        return (
            <div style={{marginTop: "0px"}}>
                <div style={{fontSize: 14, color: textColor, height: "20px"}}>{this.state.buffer[params.row.id].get(params.field)}</div>
            </div>
        );
    };

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        }
        if (name === "Status Cell") {
            return this.renderStatusCell;
        }
        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "Add User Group To User") {
            this.setState({renderTarget: "Add User Group To User"});
        } else if (identifier === "Disassociate User Group") {
            this.setState({renderTarget: "Disassociate User Group"});
        }
        super.handleMenuClick(identifier);
    }

    renderExtension() {
        if (this.state.renderTarget === "Add User Group To User") {
            return <EmployeeAdminUserGroupFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="New"/>;
        } else if (this.state.renderTarget === "Disassociate User Group") {
            return <EmployeeAdminUserGroupFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Delete" />;
        }
    };

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderStatusCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let status;
        let backgroundColor;
        let content = [];

        if (this.state.buffer[params.row.id].get("Status") === 'Active') {
            status = "ACTIVE";
            backgroundColor = Blue3;
            content.push(<Chip id="1" label={status} size="small" style={{minWidth: "80px", fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: "1px", paddingTop: "2px"}}/>)
        } else {
            status = "INACTIVE";
            backgroundColor = "#BD2930"
            content.push(<Chip id="2" label={status} size="small" style={{minWidth: "80px", fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: "1px", paddingTop: "2px"}}/>)
        }

        return (
            <div>
                {content}
            </div>
        );
    };

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-9px", paddingLeft: "8px", marginRight: "auto", marginTop: "auto", marginBottom: "auto", height: "100%"}}>
                <IconButton className={css_buttons.blueIconButton} onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Disassociate User Group"});
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Disassociate User Group</Typography>
                    </MenuItem>
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(EmployeeAdminUserGroupTable)));